import Layout from '../components/Layout';
import HeroArea from '../components/HeroArea/HeroArea';
import Cars from './Cars';
import Filter from './Filter';
import { useEffect, useState } from 'react';
import { Container } from '@mui/material';
import { collection, onSnapshot, orderBy, query } from '@firebase/firestore';
import { db } from '../config/firebaseConfig';

const Home = () => {
  const [resultsFound, setResultsFound] = useState();
  const [searchValue, setSearchValue] = useState();
  const [price, setPrice] = useState([0, 100000]);
  const [currentCar, setCurrentCar] = useState(null);

  const [model, setModel] = useState();
  const [modelList, setModelList] = useState([]);
  const [car, setCar] = useState([]);
  const [brand, setBrand] = useState('');

  let uniqueCarsBrand = [...new Set(car.map((item) => item.brand))];
  let uniqueCarsModel = [...new Set(car.map((item) => item.model))];

  useEffect(() => {
    let modelList = [];
    car.map((item) => {
      const carBrand = item.brand;
      if (carBrand?.toLowerCase() === brand?.toLowerCase()) {
        modelList.push(item.model);
      }
    });
    setModelList(modelList);
  }, [brand]);

  // get data from fireStore
  useEffect(
    () =>
      onSnapshot(
        query(collection(db, 'carPost'), orderBy('timestamp', 'desc')),
        (snapshot) => {
          setCar(
            snapshot.docs?.map((doc) => {
              return {
                id: doc.id,
                ...doc.data(),
              };
            })
          );
        }
      ),
    []
  );

  const onBrandChange = (event, value) => {
    setBrand(value);
  };

  const onModelChange = (event, value) => {
    setModel(value);
  };
  const onPriceHandler = (e, value) => {
    setPrice(value);
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const applyFilters = () => {
    let carList = car;

    // brand filter
    if (brand) {
      carList = carList?.filter((item) => item?.brand?.includes(brand));
    }

    // model type filter
    if (model) {
      carList = carList.filter((item) => item?.model?.includes(model));
    }

    if (price) {
      const minPrice = price[0];
      const maxPrice = price[1];

      carList = carList?.filter(
        (item) => item?.price >= minPrice && item?.price <= maxPrice
      );
    }

    // Search Filter
    if (searchValue) {
      carList = carList.filter(
        (item) =>
          item?.brand.toLowerCase().search(searchValue.toLowerCase().trim()) !==
            -1 ||
          item?.model.toLowerCase().search(searchValue.toLowerCase().trim()) !==
            -1 ||
          item?.engine
            .toLowerCase()
            .search(searchValue.toLowerCase().trim()) !== -1
      );
    }

    setCurrentCar(carList);

    !carList.length ? setResultsFound(false) : setResultsFound(true);
  };

  useEffect(() => {
    applyFilters();
  }, [searchValue, car, model, price, brand]);

  useEffect(() => {
    applyFilters();
  }, []);

  return (
    <Layout>
      <HeroArea />
      {/* filter options */}
      <Container style={{ paddingTop: '40px' }}>
        <Filter
          searchValue={searchValue}
          handleSearch={handleSearch}
          onModelChange={onModelChange}
          model={model}
          onPriceHandler={onPriceHandler}
          price={price}
          onBrandChange={onBrandChange}
          brand={brand}
          brandName={uniqueCarsBrand}
          modelName={
            modelList && modelList.length > 0 ? modelList : uniqueCarsModel
          }
        />
      </Container>
      <Container style={{ padding: '50px 0' }}>
        <Cars data={currentCar} resultsFound={resultsFound} />
      </Container>
    </Layout>
  );
};

export default Home;
